import { render, staticRenderFns } from "./BookingPage.vue?vue&type=template&id=b74d5d9a"
import script from "./BookingPage.vue?vue&type=script&lang=js"
export * from "./BookingPage.vue?vue&type=script&lang=js"
import style0 from "./BookingPage.vue?vue&type=style&index=0&id=b74d5d9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports